import { SVGProps, Ref, forwardRef } from 'react';

export const ImageHyperstarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m9.21 11.742 2.414-1.897 3.445 2.845C14.343 15.062 12.485 15.5 8 15.5c-4.487 0-6.344-.438-7.07-2.813L5.58 8.895z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5c6.562 0 7.5.938 7.5 7.5 0 1.228-.033 2.26-.129 3.124l-3.725-3.077L9.21 9.962l-3.646-2.86L.63 11.125C.532 10.26.5 9.228.5 8c0-1.224.032-2.252.128-3.115.461.426.887.912 1.207 1.391L3 8.023l1.165-1.747a8.1 8.1 0 0 1 2.111-2.111L8.023 3 6.276 1.835A8 8 0 0 1 4.885.628C5.748.532 6.776.5 8 .5m2.331 3.232c-.461 0-.784.155-.988.4-.202.243-.279.56-.279.867s.077.624.279.866c.204.246.527.4.988.4s.784-.154.988-.4c.202-.242.279-.56.279-.866s-.077-.624-.279-.866c-.204-.246-.527-.4-.988-.4"
                    fill="currentColor"
                />
                <path
                    d="M3 .5A9.5 9.5 0 0 0 5.5 3 9.5 9.5 0 0 0 3 5.5 9.5 9.5 0 0 0 .5 3 9.5 9.5 0 0 0 3 .5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ImageHyperstarFilledSize16Glyph.displayName = 'ImageHyperstarFilledSize16Glyph';
